<template>
  <button class="hint-button">
    <span class="information-icon">
      <svg width="8.408" height="22.852" viewBox="0 0 8.408 22.852" xmlns="http://www.w3.org/2000/svg"><g id="svgGroup" stroke-linecap="round" fill-rule="evenodd" font-size="9pt" stroke="#000" stroke-width="0" fill="#ffffff" style="stroke:#000;stroke-width:0;fill:#ffffff"><path d="M 8.408 22.852 L 0.176 22.852 L 0.176 20.449 L 2.3 20.01 L 2.3 9.858 L 0 9.419 L 0 7.002 L 6.284 7.002 L 6.284 20.01 L 8.408 20.449 L 8.408 22.852 Z M 6.284 3.53 L 2.153 3.53 L 2.153 0 L 6.284 0 L 6.284 3.53 Z" /></g></svg>
    </span>
  </button>
</template>

<script>
export default {
  name: 'HintButton',
};
</script>

<style lang="scss" scoped>
$size: 30px;
$size2: math.div($size, 2);

$colorHintButton: #45A4CD;

.hint-button {
  border-radius: $size2;
  width: $size;
  height: $size;
  border: 1px solid white;
  background-color: $colorHintButton;
  font-weight: bold;
  color: white;
  position: absolute;
  top: 7px;
  right: 10px;
  transition: background-color;
  transition-duration: 200ms;
  transition-timing-function: ease-out;

  &:hover {
    background-color: darken($colorHintButton, 20%);
  }

  .information-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 4px;

    // https://danmarshall.github.io/google-font-to-svg-path/
    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
